import {
  GET_ADMIN_USER_ROLES,
  GET_ADMIN_USER_ROLES_SUCCESS,
  GET_ADMIN_USER_ROLES_ERROR,
  CREATE_ADMIN_USER_ROLE,
  CREATE_ADMIN_USER_ROLE_SUCCESS,
  CREATE_ADMIN_USER_ROLE_ERROR,
  UPDATE_ADMIN_USER_ROLE,
  UPDATE_ADMIN_USER_ROLE_SUCCESS,
  UPDATE_ADMIN_USER_ROLE_ERROR,
  DELETE_ADMIN_USER_ROLE,
  DELETE_ADMIN_USER_ROLE_SUCCESS,
  DELETE_ADMIN_USER_ROLE_ERROR,
  RESET_LAST_COMPLETED_ACTION_OF_ADMIN_USER_ROLES,
  ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE,
  ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE_SUCCESS,
  ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE_ERROR
} from "./actionTypes"

// FOR GET ADMIN USER ROLE
export const getAdminUserRoles = () => {
  return {
    type: GET_ADMIN_USER_ROLES,
  }
}

export const getAdminUserRolesSuccess = admin_users => {
  return {
    type: GET_ADMIN_USER_ROLES_SUCCESS,
    payload: admin_users,
  }
}

export const getAdminUserRolesError = error => {
  return {
    type: GET_ADMIN_USER_ROLES_ERROR,
    payload: error,
  }
}

// FOR CREATE ADMIN USER ROLE

export const createAdminUserRoles = (admin_users, history) => {
  return {
    type: CREATE_ADMIN_USER_ROLE,
    payload: {admin_users, history},
  }
}

export const createAdminUserRolesSuccess = admin_users => {
  return {
    type: CREATE_ADMIN_USER_ROLE_SUCCESS,
    payload: admin_users,
  }
}

export const createAdminUserRolesError = error => {
  return {
    type: CREATE_ADMIN_USER_ROLE_ERROR,
    payload: error,
  }
}

// FOR UPDATE ADMIN USER ROLE
export const updateAdminUserRoles = (admin_users, history) => {
  return {
    type: UPDATE_ADMIN_USER_ROLE,
    payload: {admin_users, history},
  }
}

export const updateAdminUserRolesSuccess = admin_users => {
  return {
    type: UPDATE_ADMIN_USER_ROLE_SUCCESS,
    payload: admin_users,
  }
}

export const updateAdminUserRolesError = error => {
  return {
    type: UPDATE_ADMIN_USER_ROLE_ERROR,
    payload: error,
  }
}

// FOR DELETE ADMIN USER ROLE
export const deleteAdminUserRoles = (admin_users) => {
  return {
    type: DELETE_ADMIN_USER_ROLE,
    payload: admin_users,
  }
}

export const deleteAdminUserRolesSuccess = admin_users => {
  return {
    type: DELETE_ADMIN_USER_ROLE_SUCCESS,
    payload: admin_users,
  }
}

export const deleteAdminUserRolesError = error => {
  return {
    type: DELETE_ADMIN_USER_ROLE_ERROR,
    payload: error,
  }
}

export const resetLastCompletedActionOfAdminUserRoles = () => {
  return {
    type: RESET_LAST_COMPLETED_ACTION_OF_ADMIN_USER_ROLES,
  }
}

export const addNotificationTemplateToAdminRole = (payload) => {
  return {
    type: ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE,
    payload: payload,
  }
}

export const addNotificationTemplateToAdminRoleSuccess = (payload) => {
  return {
    type: ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE_SUCCESS,
  }
}

export const addNotificationTemplateToAdminRoleError = (error) => {
  return {
    type: ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE_ERROR,
  }
}